import { MutationTree } from 'vuex';

import { State } from './state';
import { AuthMutationTypes } from './mutation-types';

export type Mutations<S = State | any> = {
  [AuthMutationTypes.LOGIN_SUCCESS](state: S, integracao: any): void;
  [AuthMutationTypes.LOGOUT](state: S): void;
  [AuthMutationTypes.UPDATE_USUARIO_ID](state: S, segUsuarioId: number): void;
  [AuthMutationTypes.SET_TOKEN_LEGACY](token: string): void;
};

export const mutations: MutationTree<State | any> & Mutations = {
  [AuthMutationTypes.LOGIN_SUCCESS](state: State, integracao: any) {
    state.integracao.usuarioIntegracaoId = integracao.segUsuarioId;
    state.integracao.code = integracao.code;
    state.integracao.grupoUsuario = integracao.grupoUsuario;
    state.integracao.tiposFornecimentoAtivos = integracao.tiposFornecimentoAtivos ?? [];
    localStorage.setItem('integracao', JSON.stringify(state.integracao));
  },
  [AuthMutationTypes.UPDATE_USUARIO_ID](state: State, segUsuarioId: number) {
    state.integracao.usuarioIntegracaoId = segUsuarioId;
    localStorage.setItem('integracao', JSON.stringify(state.integracao));
  },
  [AuthMutationTypes.LOGOUT](state: State) {
    state.oidc.value.userManager!.signoutRedirect();
    localStorage.removeItem('integracao');
    localStorage.removeItem('messages');
    localStorage.removeItem('ultimaObraSelecionada');
  },
  [AuthMutationTypes.SET_TOKEN_LEGACY](token: string) {
    sessionStorage.setItem('tokenLegacy', token);
    sessionStorage.setItem('isLegacy', '1');
  }
};
